(function () {
  'use strict';

  var styleLuckyDrop = function () {
    var host = document.querySelector('lucky-drop-widget');
    if (!host || !host.shadowRoot || host.shadowRoot.querySelector('[data-kbd-lucky-drop-offset]')) return false;
    var style = document.createElement('style');
    style.setAttribute('data-kbd-lucky-drop-offset', '');
    style.textContent = '#widget-launcher,#widget-dismiss{translate:0 -88px!important;}';
    host.shadowRoot.appendChild(style);
    return true;
  };

  var initFloatingWidgets = function () {
    if (styleLuckyDrop()) return;
    var observer = new MutationObserver(function () {
      if (!styleLuckyDrop()) return;
      observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingWidgets, { once: true });
  } else {
    initFloatingWidgets();
  }
})();
